import Vue from 'vue'
import Vuex from 'vuex'
import Login from '@/stores/modules/Login'
import TopMenu from '@/stores/modules/TopMenu'
import LatestMenu from '@/stores/modules/LatestMenu'
import AtmWsStore from '@/stores/modules/AtmWsStore.js'
import ModalStore from '@/stores/modules/ModalStore.js'

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    Login,
    TopMenu,
    LatestMenu,
    AtmWsStore,
    ModalStore
  }
})



// WEBPACK FOOTER //
// ./src/stores/index.js